import { useQuery } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const usePaymentPlan = (isStripe: boolean, isSuspended = false, isTrialer = false, enabled = true) => {
  const query = useQuery({
    queryKey: [QueryKeys.PAYMENT_PLAN, { isStripe, isSuspended, isTrialer }],
    queryFn: () => paymentRepo.getPaymentPlan(isStripe, isSuspended, isTrialer),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled,
  });

  return useQueryMemoized(query);
};

export type UsePaymentPlan = ReturnType<typeof usePaymentPlan>;
